import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PartnerChannelService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/partnerchannels`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<Boo.Objects.PartnerChannel[]> {
    return this.http.get<Boo.Objects.PartnerChannel[]>(`${this.baseUrl}/GetAll`);
  }
}